import { Link } from 'react-router-dom';
import { categories } from '@/mocks/events';

const aboutLinks = [
  { to: '/about', label: '关于瓜迹' },
  { to: '/about#method', label: '内容梳理原则' },
  { to: '/events', label: '全部事件时间轴' },
  { to: '/about#contact', label: '联系我们' },
];

export default function Footer() {
  return (
    <footer className="mt-auto border-t border-background-300/60 bg-secondary-100/70">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4 lg:gap-12">
          <div className="col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg text-background-50">瓜</span>
              <div className="leading-tight">
                <p className="font-heading text-xl font-semibold text-foreground-950">瓜迹</p>
                <p className="text-[10px] tracking-[0.18em] text-foreground-500">热点事件时间轴</p>
              </div>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              按节点梳理每起热点事件的经过与进展，从爆发到后续追踪一目了然。追更吃瓜动态，看懂事件如何一步步演变。
            </p>
            <div className="mt-4 flex gap-2">
              <a href="#" aria-label="微博" className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"><i className="ri-weibo-fill text-base" /></a>
              <a href="#" aria-label="微信" className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"><i className="ri-wechat-fill text-base" /></a>
              <a href="#" aria-label="抖音" className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"><i className="ri-music-2-fill text-base" /></a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950"><a href="/events" className="hover:text-primary-700">事件栏目</a></h4>
            <ul className="mt-4 space-y-2.5">
              {categories.filter((c) => c !== '全部').map((c) => (
                <li key={c}>
                  <Link to={`/events?cat=${encodeURIComponent(c)}`} className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                    {c}时间轴
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">关于我们</h4>
            <ul className="mt-4 space-y-2.5">
              {aboutLinks.map((l) => (
                <li key={l.label}>
                  <a href={l.to} className="text-sm text-foreground-600 transition-colors hover:text-primary-700">{l.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">与我们同行</h4>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              发现事件脉络、提供新线索或纠错反馈，欢迎来信，我们会认真核对并持续补全时间线。
            </p>
            <a
              href="mailto:hello@guaji.team"
              className="mt-3 inline-flex items-center gap-1.5 rounded-md bg-accent-500 px-3 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
            >
              <i className="ri-mail-send-line" /> hello@guaji.team
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300/70 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            瓜迹内容基于公开信息与多方信源梳理，旨在帮助读者快速了解事件经过，不代表本站观点。
          </p>
          <p className="text-xs text-foreground-500">© 2026 瓜迹 · 吃瓜事件时间轴 · 持续更新中</p>
        </div>
      </div>
    </footer>
  );
}